// src/modules/fire/icons/PortoSeguroLogo.tsx
import * as React from "react";

export interface PortoSeguroLogoProps extends React.SVGProps<SVGSVGElement> {
	width?: number | string; // default 105
	height?: number | string; // default 24
	primaryColor?: string; // default "#00A1FC"
}

export const PortoSeguroLogo = React.forwardRef<SVGSVGElement, PortoSeguroLogoProps>(
	({ width = 105, height = 24, primaryColor = "#00A1FC", ...props }, ref) => {
		// Evita colisão de IDs do clipPath quando várias instâncias são renderizadas
		const clipId = React.useId();

		return (
			<svg
				ref={ref}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 105 24"
				width={width}
				height={height}
				fill="none"
				preserveAspectRatio="xMidYMid meet"
				{...props}
			>
				<g clipPath={`url(#${clipId})`}>
					<path
						d="M95.847 20.4014C93.0495 20.4014 91.1871 18.2658 91.1871 15.1845C91.1871 12.1032 93.0515 9.96565 95.847 9.96565C98.6086 9.96565 100.473 12.0992 100.473 15.1825C100.473 18.2658 98.6086 20.3993 95.847 20.3993V20.4014ZM95.847 6.36572C90.7215 6.36572 87.0547 10.0917 87.0547 15.1744C87.0547 20.257 90.7155 23.981 95.847 23.981C100.939 23.981 104.601 20.2549 104.601 15.1744C104.601 10.0938 100.939 6.37589 95.847 6.37589"
						fill={primaryColor}
					/>
					<path
						d="M77.1094 1.49902V17.7597C77.1094 21.5529 79.5073 23.721 83.1681 23.721H85.8957V19.9604H83.6337C82.103 19.9604 81.2038 19.0797 81.2038 17.353V10.1368H85.8957V6.64672H81.2038V1.49902H77.1094Z"
						fill={primaryColor}
					/>
					<path
						d="M69.3561 23.7207V13.0165C69.3561 11.2877 70.2554 10.4071 71.786 10.4071H75.0452V6.64648H71.3204C67.6576 6.64648 65.2617 8.81458 65.2617 12.6098V23.7207H69.3561Z"
						fill={primaryColor}
					/>
					<path
						d="M54.6986 20.4019C51.901 20.4019 50.0386 18.2663 50.0386 15.185C50.0386 12.1037 51.903 9.96614 54.6986 9.96614C57.4602 9.96614 59.3246 12.0997 59.3246 15.183C59.3246 18.2663 57.4602 20.3998 54.6986 20.3998V20.4019ZM54.6986 6.36621C49.5731 6.36621 45.9062 10.0922 45.9062 15.1748C45.9062 20.2575 49.583 23.9998 54.6986 23.9998C59.7901 23.9998 63.451 20.2737 63.451 15.1932C63.451 10.1126 59.7901 6.38451 54.6986 6.38451"
						fill={primaryColor}
					/>
					<path
						d="M37.8552 10.9503H33.1293V3.76874H37.8552C40.4529 3.76874 41.518 5.46091 41.518 7.3585C41.518 9.25609 40.4529 10.9503 37.8552 10.9503ZM38.055 0.00813562H28.7031V23.7209H33.1293V14.7109H38.055C42.9147 14.7109 45.8102 11.6601 45.8102 7.3585C45.8102 3.05689 42.9147 0 38.055 0"
						fill={primaryColor}
					/>
					<path
						d="M21.4631 12.8985C19.3048 10.3089 12.1862 11.6634 6.64114 13.3967C6.62595 13.4031 6.60939 13.4058 6.59291 13.4044C6.57643 13.4031 6.56053 13.3979 6.54661 13.3891C6.53269 13.3804 6.52118 13.3684 6.51309 13.3543C6.50499 13.3402 6.50057 13.3244 6.5002 13.3082C6.5002 13.0344 6.51282 12.7565 6.51282 12.4848C6.51836 11.105 6.40011 9.72735 6.15941 8.36778C6.15629 8.34496 6.16216 8.32183 6.17583 8.3031C6.18951 8.28436 6.20997 8.27142 6.23304 8.26692C10.8231 6.62012 20.0684 6.12197 21.6503 12.8265C21.6756 12.9253 21.5262 12.9829 21.461 12.9006L21.4631 12.8985ZM16.8162 20.4203C16.6648 20.5294 16.467 20.3503 16.6059 20.2144C18.8399 17.9789 20.6742 14.4342 4.48705 21.6554C4.38818 21.6986 4.28932 21.5977 4.35453 21.5175C5.24645 20.2824 6.03741 18.2609 6.40133 15.412C6.40347 15.3942 6.41046 15.3774 6.42157 15.3633C6.43268 15.3492 6.44749 15.3382 6.46444 15.3317C16.608 11.3444 28.0663 11.4926 16.8247 20.4244L16.8162 20.4203ZM3.28169 2.5937C3.26223 2.58413 3.24684 2.56815 3.23823 2.54857C3.22963 2.52899 3.22835 2.50707 3.23463 2.48666C3.24092 2.46625 3.25435 2.44866 3.27258 2.43699C3.29081 2.42532 3.31265 2.42031 3.33428 2.42285C6.14048 2.42285 14.5948 2.217 18.9535 7.6576C19.0124 7.75229 18.8757 7.84698 18.7894 7.77288C17.4747 6.65306 13.9154 4.75718 5.71135 6.41633C5.68486 6.42352 5.65655 6.42048 5.63228 6.40784C5.60801 6.3952 5.58963 6.37392 5.58092 6.3484C4.92881 4.30637 4.10841 3.20096 3.28169 2.5937V2.5937ZM21.3032 0H2.86939C2.10318 0.00544083 1.37053 0.308376 0.832491 0.842218C0.294447 1.37606 -0.00496201 2.09712 7.71114e-05 2.8469V21.151C-0.00269545 21.5225 0.0693234 21.8908 0.212021 22.235C0.354719 22.5792 0.565301 22.8925 0.831743 23.1571C1.09818 23.4216 1.41527 23.6322 1.76489 23.7768C2.11451 23.9215 2.48982 23.9973 2.86939 24H21.3032C21.6828 23.9973 22.0581 23.9215 22.4077 23.7768C22.7573 23.6322 23.0744 23.4216 23.3409 23.1571C23.6073 22.8925 23.8179 22.5792 23.9606 22.235C24.1033 21.8908 24.1753 21.5225 24.1725 21.151V2.85513C24.1761 2.48319 24.1047 2.1142 23.9624 1.76929C23.8201 1.42438 23.6096 1.11034 23.3431 0.845128C23.0766 0.57992 22.7592 0.36876 22.4092 0.223741C22.0592 0.0787214 21.6833 0.00269042 21.3032 0"
						fill={primaryColor}
					/>
				</g>
				<defs>
					<clipPath id={clipId}>
						<rect width="105" height="24" fill="white" />
					</clipPath>
				</defs>
			</svg>
		);
	}
);

PortoSeguroLogo.displayName = "PortoSeguroLogo";
